const PASSWORD_SELECTOR = '.password-input input';
const PASSWORD_BUTTON_SELECTOR = '.password-input button.show-hide';

$(document).on('click', PASSWORD_BUTTON_SELECTOR, (e) => {
  const button = $(e.target);
  const passwordField = button.siblings('input');

  if (passwordField.attr('type') === 'text') {
    passwordField.attr('type', 'password');
    button.text(button.data('text-show'));
  } else {
    passwordField.attr('type', 'text');
    button.text(button.data('text-hide'));
  }
});
